import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// Load store modules dynamically.
const moduleFiles = import.meta.glob('./modules/*.js', { eager: true })

const modules = Object.entries(moduleFiles)
  .map(([file, module]) =>
    [file.replace(/^.*\/|\.(js)$/g, ''), module.default || module]
  )
  .reduce((modules, [name, module]) => ({
    ...modules,
    [name]: {
      namespaced: true,
      ...module
    }
  }), {})

export default new Vuex.Store({
  modules
})
